import { Injectable } from '@angular/core';

enum AUTH {
  LOGIN = '/auth/login',
  LOGOUT = '/auth/logout',
  REFRESH_TOKEN = '/auth/refreshToken',
  RECUPERA_PASSWORD = '/user/recupera-password'
}
enum CONFIG {
  INIT = '/configuration/init'
}
enum USER {
  GET = '/user/get',
  ADD = '/user/add',
  UPDATE = '/user/update',
  REMOVE = '/user/remove',
  LIST = '/user/list',
  CHANGE_PASSWORD = '/user/changePassword',
  ADMIN_CHANGE_PASSWORD = '/user/adminChangePassword'
}

enum GROUP {
  GET = '/group/get',
  ADD = '/group/add',
  UPDATE = '/group/update',
  REMOVE = '/group/remove',
  LIST = '/group/list',
  GET_USERS_BY_GROUPS = '/group/getUsersByGroups'
}
enum PERMISSION {
  GET = '/permission/get',
  ADD = '/permission/add',
  UPDATE = '/permission/update',
  REMOVE = '/permission/remove',
  LIST = '/permission/list'
}
enum AREA {
  LIST = '/area/list'
}
enum LOG {
  LIST = '/log/list'
}
enum MAP_CORE {
  SELECT = '/map/select',
  SELECT_BY_URN = '/map/selectByUrns',
  SELECT_BY_URNS = '/map/selectByUrns',
  REPORT_BY_URN = '/map/reportByUrn',
  REPORT_BY_URNS = '/map/reportByUrns',
  SEARCH = '/map/search',
  CHECK_GRANT = '/map/checkGrant',
  GET_AREA_INFO = '/map/getAreaInfo'
}
enum MAP_LAYER {
  // data
  ADD_LAYER_FILE = '/layerData/add',
  ADD_LAYER_THIRDPARTY = '/layerData/loadThirdParty',
  UPDATE_LAYER = '/layerData/update',
  DELETE_LAYER = '/layerData/delete',
  GET_INFO = '/layerData/getInfo',
  // style
  STYLES = '/layerStyle/styles',
  GET_LEGEND = '/layerStyle/legend',
  ADD_STYLE = '/layerStyle/add',
  UPDATE_STYLE = '/layerStyle/update',
  GET_STYLE = '/layerStyle/get',
  GET_BASE = '/layerData/base',
  // history
  LAYER_HYSTORY = '/layer/getDates' // TODO la rotta completa era /saas/layer/getDates. Va aggiunta nel nuovo map-microservice
}
enum MAP_BOOKMARK {
  GET = '/bookmark/get',
  LIST = '/bookmark/list',
  ADD = '/bookmark/add',
  UPDATE = '/bookmark/update',
  DELETE = '/bookmark/delete',
  GET_FAVOURITE = '/bookmark/getFavourite',
  SET_FAVOURITE = '/bookmark/setFavourite'
}
enum MAP_QUERY {
  GET = '/query/get',
  LIST = '/query/list',
  ADD = '/query/add',
  UPDATE = '/query/update',
  DELETE = '/query/delete',
  CREATION = '/query/creation',
  EXEC = '/query/exec',
  EXTRACT = '/query/extract'
}
enum MAP_WATER {
  VALVE_SEACH = '/valvole/search'
}
enum MAP_TELCO {
  STUCTURE = '/telco/structure',
  ESTREMI_OTDR_DA_SEGMENTO = '/telco/estremi_otdr_da_segmento',
  OTDR_START = '/telco/otdr_start',
  OTDR_START_DEFAULT = '/telco/otdr_start_default',
  SCHIACCIAMENTO = '/telco/schiacciamento',
  SHOW_CONTRACT_DOCUMENT = '/telco/show_contract_document',
  REPORT_CONNECTIVITY = '/telco/report_connectivity',
  EXPORT_KMZ = '/telco/kmz',
  TRACCIATO_IRU = '/telco/getTracciatoIRU'
}
enum MAP_EXPORT {
  CSV = '/export/csv',
  EXCEL = '/export/excel',
  PDF = '/export/pdf',
  PDF_CHECKLIST = '/export/pdf_checklist',
  SHAPE = '/export/shape',
  HTML = '/export/html',
  DXF = '/export/dxf',
  PLOT_TEMPLATES = '/plotting/getTemplates',
  PLOT = '/plotting/plot'
}
enum TRACING {
  SHORTEST_PATH = '/tracing/shortestPath',
  TRACE_OUT = '/tracing/traceOut'
}
enum NOTIFICATION {
  GET = '/notification/get',
  LIST = '/notification/list',
  ADD = '/notification/add',
  READ = '/notification/read',
  UPDATE = '/notification/update',
  CATEGORY_LIST = '/notification/category/list', // TODO rivedere
  PRIORITY_LIST = '/notification/priority/list', // TODO rivedere
  TYPE_LIST = '/notification/type/list' // TODO rivedere
}
enum PSA {
  ADD_ACTION = '/psa/addAction',
  GET_ACTION = '/psa/getAction',
  DELTE_ACITON = '/psa/deleteAction',
  LIST_ACTION = '/psa/listActions',
  ATTACH_ACTION_TO_EVENT = '/psa/attachActionToEvent',
  ADD_EVENT = '/psa/addEvent',
  DELETE_EVENT = '/psa/deleteEvent',
  UPDATE_EVENT = '/psa/updateEvent',
  UPDATE_REL_ENTITY_EVENTO_RISCHIO = '/psa/updateRelEntityEventoRischio',
  UPDATE_REL_ENTITY_EVENTO_RISCHIO_STATE = '/psa/updateRelEntityEventoRischioState',
  GET_EVENT = '/psa/getEvent',
  LIST_EVENTS = '/psa/listEvents',
  GET_EVENT_ACTIONS = '/psa/getEventActions',
  LIST_ENTITIES = '/psa/listEntities',
  GET_DETAIL = '/psa/getDetail',
  ATTACH_EVENT_TO_ENTITIES = '/psa/attachEventToEntities',
  ATTACH_EVENTS_TO_ENTITY = '/psa/attachEventsToEntity',
  ATTACH_ACTION_TO_ENTITY = '/psa/attachActionToEntity',
  REMOVE_EVENT_FROM_ENTITY = '/psa/removeEventFromEntity',
  REMOVE_MULTIPLE_EVENTS_FROM_ENTITY = '/psa/removeMultipleEventsFromEntity',
  REMOVE_ACTION_FROM_ENTITY = '/psa/removeActionFromEntity',
  DUPLICATE_RISK_MATRIX = '/psa/duplicateRisksMatrix',
  DUPLICATE_CHECK_LIST = '/psa/duplicateChecklist',
  LIST_AREAS = '/psa/listAreas',
  GET_ENTITY_TYPES = '/psa/getEntityTypes',
  SELECT = '/psa/select',
  GET_CHECKLIST = '/psa/getCheckList',
  GET_CHECKLIST_ANSWERS = '/psa/getCheckListAnswers',
  GET_CHECKLIST_ELEMENT_TYPES = '/psa/getChecklistElementTypes',
  UPSERT_CHECKLIST_ANSWERS = '/psa/upsertCheckListAnswers',
  STATO_AVANZAMENTO = '/psa/statoAvanzamento',
  MATRICE_RISCHIO = '/psa/matriceRischio',
  EXPORT_MATRICE_RISCHIO = '/psa/exportMatriceRischio',
  EXPORT_EXCEL_MATRICE_RISCHIO = '/psa/exportExcelMatriceRischio',
  SAVE_PDF_CHECKLIST = '/psa/savePdfChecklist',
  BULK_MATRIX_INSERT = '/psa/bulkMatrixInsert',
  FILESYSTEM_GET = '/psa/filesystem/get',
  FILESYSTEM_CHECK_ELEMENT = '/psa/filesystem/element',
  FILESYSTEM_FILE_CREATE = '/psa/filesystem/file/create',
  FILESYSTEM_FILE_DELETE = '/psa/filesystem/file',
  FILESYSTEM_FILE_MOVE = '/psa/filesystem/file',
  FILESYSTEM_FOLDER_CREATE = '/psa/filesystem/folder/create',
  FILESYSTEM_FOLDER_UPDATE = '/psa/filesystem/folder',
  FILESYSTEM_FOLDER_DELETE = '/psa/filesystem/folder',
  FILESYSTEM_GET_FILE = '/psa/filesystem/getFile',
  CREATE_INTERCONNECTION = '/psa/interconnection/add',
  DELETE_INTERCONNECTION = '/psa/interconnection/delete',
  ADD_NODE = '/psa/node/add',
  DELETE_NODE = '/psa/node/delete',
  UPDATE_NODE = '/psa/node/update'
}

enum CONTROLLI {
  PRELIEVI_VALIDA = '/psa/controlli/prelievi/valida',
  PRELIEVI = '/psa/controlli/prelievi',
  SUPERAMENTI_VALIDA = '/psa/controlli/superamenti/valida',
  SUPERAMENTI = '/psa/controlli/superamenti',
  PARAMETRI_ANALITICI = '/psa/controlli/parametri-analitici',
  SUPERAMENTI_CODICI = '/psa/controlli/superamenti/codici',
  TIPOLOGIE_PUNTO_CAMPIONAMENTO = '/psa/controlli/tipologie-punto-campionamento',
  RISCHIO_PUNTI = '/psa/controlli/rischio-analitico/punti',
  RISCHIO_HEATMAP = '/psa/controlli/rischio-analitico/heatmap',
  RISCHIO_RIEPILOGO = '/psa/controlli/rischio-analitico/riepilogo',
  RISCHIO_PUNTO_DETTAGLIO = '/psa/controlli/rischio-analitico/punti',
  RISCHIO_COMUNI = '/psa/controlli/rischio-analitico/comuni'
}

enum ANTEA {
  LOGIN = '/psa/controlli/antea/login',
  WSZ = '/psa/controlli/antea/wsz',
  TRASMETTI_CONTROLLI = '/psa/controlli/antea/trasmetti-controlli',
  ELABORAZIONE = '/psa/controlli/antea/elaborazione',
  TRASMETTI_SUPERAMENTI = '/psa/controlli/antea/trasmetti-superamenti'
}

enum CHECKIN {
  LIST = '/attivita/checkin/list',
  LIST_USERS = '/attivita/filterconfig/users',
  ANALYSIS = '/attivita/checkin/analysis',
  STORICO_TO_OPEN = '/attivita/checkin/analysis/storicoToOpen'
}
enum SMART_COMPONENT {
  GET_ATTACHMENTS = '/smart-component/restrictedArea/getattach',
  SAVE_ATTACHMENTS = '/smart-component/restrictedArea/saveattachments',
  APK_LIST = '/smart-component/apk/list',
  APK_PUT = '/smart-component/apk/put',
  APK_GET = '/smart-component/apk/get'
}

enum APP_MESSAGES {
  LIST = '/app-message/list',
  GET = '/app-message/get',
  GET_ACTIVE_MESSAGES = '/app-message/get_active_messages',
  CREATE = '/app-message/create',
  UPDATE = '/app-message/update'
}

enum MAIL_MESSAGES {
  LIST = '/mail-message/list',
  GET = '/mail-message/get',
  CREATE = '/mail-message/create',
  UPDATE = '/mail-message/update',
  DELETE = '/mail-message/delete'
}

enum JOINTS {
  BASE = '/raccordo',
  LIST = '/raccordo/list',
  GET = '/raccordo/get',
  ADD = '/raccordo/add',
  UPDATE = '/raccordo/update',
  DELETE = '/raccordo/delete',
  UPLOAD = '/raccordo/upload',
  DOWNLOAD = '/raccordo/download',
  AUTOCOMPLETE_EDIFICI = '/raccordo/autocomplete'
}
enum FIBER {
  LIST = '/fibra/list',
  GET = '/fibra/get',
  UPDATE = '/fibra/update',
  HISOTRY = '/fibra/history'
}
enum FATTIBILITA {
  BASE = '/fattibilita'
}

enum COMPANY {
  LIST = '/company/list',
  ADD = '/company/add',
  UPDATE = '/company/update',
  DELETE = '/company/delete',
  LIST_USERS = '/company/listCompanyUsers',
  LINK_USER = '/company/linkUserCompany',
  AUTOCOMPLETE_USERS = '/company/autocompleteUsers',
  GET_USER_COMPANY = '/company/getUserCompany'
}

export const API_URLS = {
  AUTH,
  CONFIG,
  USER: { ...USER, COMPANY: COMPANY },
  GROUP,
  PERMISSION,
  AREA,
  LOG,
  MAP: {
    CORE: MAP_CORE,
    LAYER: MAP_LAYER,
    BOOKMARK: MAP_BOOKMARK,
    QUERY: MAP_QUERY,
    WATER: MAP_WATER,
    TELCO: MAP_TELCO,
    EXPORT: MAP_EXPORT,
    TRACING: TRACING
  },
  PSA,
  CONTROLLI,
  ANTEA,
  NOTIFICATION,
  CHECKIN,
  SMART_COMPONENT,
  APP_MESSAGES,
  MAIL_MESSAGES,
  FIBER_JOINTS: {
    FIBER: FIBER,
    JOINTS: JOINTS
  },
  FATTIBILITA
};

@Injectable({
  providedIn: 'root'
})
export class ApiUrlService {
  constructor() { }

  createUrl(path: string): string {
    return `${window.location.protocol}//${window.location.host}${path}`;
  }
}
